<template>
  <div
    v-if="healthdata"
    class="container"
  >
    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            <router-link
              class="btn btn-primary"
              :to="{name: 'scorecard'}"
            >
              &lt;&lt; Back to Scorecard
            </router-link>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Your Medical Score</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              <linear-gauge
                :show-title="false"
                :show-display-val="false"
                :show-hero-metric="true"
                :title="healthdata.scorecard.factor_groups.medical.points"
                :value="healthdata.scorecard.factor_groups.medical.percentage"
              />
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Medical History</h4>
          </div>
          <div class="card-body">
            <ul class="list-group ">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Cancer</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.conditions.cancer.has"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Diabetes</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.conditions.diabetes.has"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Cardiac (Heart) Disease</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.conditions.heart_disease.has"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>High Blood Fats</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.conditions.high_blood_fats.has"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Hypertension</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.conditions.hypertension.has"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Kidney Disease</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.conditions.kidney_disease.has"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Liver Disease</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.conditions.liver_disease.has"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Family History</h4>
          </div>
          <div class="card-body">
            <ul class="list-group ">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Cancer</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.family_history.cancer == '1'"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Diabetes</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.family_history.diabetes == '1'"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Cardiac (Heart) Disease</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.family_history.heart_disease == '1'"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>High Blood Fats</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.family_history.high_blood_fats == '1'"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Hypertension</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.family_history.hypertension == '1'"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Kidney Disease</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.family_history.kidney_disease == '1'"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <span>Liver Disease</span>
                <span>        
                  <i
                    v-if="healthdata.answers.medical.family_history.liver_disease == '1'"
                    class="fa fa-check"
                  />
                  <i
                    v-else
                    class="fa fa-times"
                  />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        v-if="healthdata.answers.medical.meds.herbal.takes"
        class="col-12 col-lg-8 offset-lg-2 mb-4"
      >
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Herbal Medications</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You take herbal medications.
            </p>
            <p
              v-if="healthdata.answers.medical.meds.herbal.desc"
              class="text-center"
            >
              <strong>Medications</strong>: {{ healthdata.answers.medical.meds.herbal.desc }}
            </p>
          </div>
        </div>
      </div>

      <div
        v-if="healthdata.answers.medical.meds.otc.takes"
        class="col-12 col-lg-8 offset-lg-2 mb-4"
      >
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Over-the-counter Medications</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You take over the counter medications.
            </p>
            <p
              v-if="healthdata.answers.medical.meds.otc.desc"
              class="text-center"
            >
              <strong>Medications</strong>: {{ healthdata.answers.medical.meds.otc.desc }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4><i class="fa fa-stethoscope" /> Lab Results</h4>
          </div>

          <div class="card-body">
            <div class="alert alert-info m-3">
              <p>Please be aware that in order to accurately calculate your Favorable Fitness Factor®, we need certain lab values from you. Lab values play a large part in analyzing your health, so if you do not have your scores at the moment, you can take the assessment by leaving any unknown's blank, but should contact your physician shortly after. We highly recommend getting yearly lab tests done. Please understand that if you cannot fill out your lab values at this time, you will have a lower Favorable Fitness Factor® score. This lower score does not indicate that you are unhealthy in any sense, our database is just missing that specific information which calculates a personalized score for you. The necessary lab tests include: Glucose, LDL, HDL, Triglycerides, Cholesterol, HgbA1c and Blood Pressure. Thank you!</p>
            </div>

            <ul class="list-group ">
              <li
                v-if="healthdata.answers.medical.labs.general.bone_density"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Bone Density
                </span>
                <span>{{ healthdata.answers.medical.labs.general.bone_density }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.bun"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  BUN
                </span>
                <span>{{ healthdata.answers.medical.labs.general.bun }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.bun_to_creatinine"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  BUN to Creatinine Ratio
                </span>
                <span>{{ healthdata.answers.medical.labs.general.bun_to_creatininme }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.cholesterol"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Cholesterol
                </span>
                <span>{{ healthdata.answers.medical.labs.general.cholesterol }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.creatinine"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Creatinine
                </span>
                <span>{{ healthdata.answers.medical.labs.general.creatinine }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.glucose"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Glucose
                </span>
                <span>{{ healthdata.answers.medical.labs.general.glucose }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.hct"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  HCT
                </span>
                <span>{{ healthdata.answers.medical.labs.general.hct }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.hdl"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  HDL
                </span>
                <span>{{ healthdata.answers.medical.labs.general.hdl }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.ldl"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  LDL
                </span>
                <span>{{ healthdata.answers.medical.labs.general.ldl }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.hgb"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  HGB
                </span>
                <span>{{ healthdata.answers.medical.labs.general.hgb }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.hgba1c"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  HGBA1C
                </span>
                <span>{{ healthdata.answers.medical.labs.general.hgba1c }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.magnesium"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Magnesium
                </span>
                <span>{{ healthdata.answers.medical.labs.general.magnesium }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.phosphorus"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Phosphorus
                </span>
                <span>{{ healthdata.answers.medical.labs.general.phosphorus }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.potassium"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Potassium
                </span>
                <span>{{ healthdata.answers.medical.labs.general.potassium }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.sgot_ast"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  SGOT/AST
                </span>
                <span>{{ healthdata.answers.medical.labs.general.sgot_ast }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.sgpt_alt"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  SGPT/ALT
                </span>
                <span>{{ healthdata.answers.medical.labs.general.sgpt_alt }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.sodium"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Sodium
                </span>
                <span>{{ healthdata.answers.medical.labs.general.sodium }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.triglycerides"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  Triglycerides
                </span>
                <span>{{ healthdata.answers.medical.labs.general.triglycerides }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.tsh"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>
                  TSH
                </span>
                <span>{{ healthdata.answers.medical.labs.general.tsh }}</span>
              </li>
              <li
                v-if="healthdata.answers.medical.labs.general.blood_pressure.systolic && healthdata.answers.medical.labs.general.blood_pressure.diastolic"
                class="list-group-item d-flex justify-content-between align-items-center"
              >                            
                <span>
                  Blood Pressure
                </span>
                <span
                  v-if="healthdata.answers.medical.labs.general.blood_pressure.systolic < 90 || healthdata.answers.medical.labs.general.blood_pressure.diastolic < 60"
                  class="text-yellow-dark"
                >Low ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
                <span
                  v-else-if="healthdata.answers.medical.labs.general.blood_pressure.systolic <= 120 && healthdata.answers.medical.labs.general.blood_pressure.diastolic <= 80"
                  class="text-green-light"
                >Normal ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
                <span
                  v-else-if="healthdata.answers.medical.labs.general.blood_pressure.systolic <= 130 && healthdata.answers.medical.labs.general.blood_pressure.diastolic <= 80"
                  class="text-yellow-dark"
                >Elevated ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
                <span
                  v-else-if="healthdata.answers.medical.labs.general.blood_pressure.systolic <= 140 && healthdata.answers.medical.labs.general.blood_pressure.diastolic <= 90"
                  class="text-red"
                >Stage I Hypertension ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
                <span
                  v-else-if="healthdata.answers.medical.labs.general.blood_pressure.systolic > 140 || healthdata.answers.medical.labs.general.blood_pressure.diastolic > 90"
                  class="text-red"
                >Stage II Hypertension ({{ healthdata.answers.medical.labs.general.blood_pressure.systolic }}/{{ healthdata.answers.medical.labs.general.blood_pressure.diastolic }})</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            <router-link
              class="btn btn-primary"
              :to="{name: 'scorecard'}"
            >
              &lt;&lt; Back to Scorecard
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    healthdata() {
      return this.$store.getters['healthData/current']
    },
  },
  mounted () {
    this.$store.dispatch('healthData/GET_INITIAL_DATA');
  }
}
</script>
